/* eslint-disable no-console */
import { call, put, takeEvery, select } from 'redux-saga/effects'

import handleError from 'models/handle-error'

import { getAnswers, getSurvey } from './selectors'
import api from './api'
import actions from './actions'

function* fetchAll({ payload }) {
  const { callback } = payload
  let isSuccess = false
  let surveys = []
  try {
    const data = yield call(api.fetchAll)
    surveys = data?.results || surveys
    yield put(actions.fetchAll.success(data))
    isSuccess = true
  } catch (error) {
    console.error('[KilliPolls] fetchAll:', error)
    yield put(handleError(error))
    yield put(actions.fetchAll.failure())
  } finally {
    if (callback) {
      yield call(callback, isSuccess, surveys)
    }
  }
}

function* fetchSurvey({ payload }) {
  try {
    const result = yield call(api.fetchSurvey, payload)
    yield put(actions.fetchSurvey.success(result))
  } catch (error) {
    console.error('[KilliPolls] fetchSurvey:', error)
    yield put(actions.fetchSurvey.failure())
  }
}

export function* submitSurvey(action) {
  const { callback } = action.payload
  let isSuccess = false
  try {
    const survey = yield select(getSurvey)
    const answers = yield select(getAnswers)
    const result = yield call(api.submitSurvey, survey.id, answers)
    yield put(actions.submitSurvey.success(result))
    isSuccess = true
  } catch (error) {
    console.error('[KilliPolls] submitSurvey:', error)
    yield put(handleError(error))
    yield put(actions.submitSurvey.failure())
  } finally {
    if (callback) {
      yield call(callback, isSuccess)
    }
  }
}

export default function* main() {
  yield takeEvery(actions.fetchAll.INIT_TYPE, fetchAll)
  yield takeEvery(actions.fetchSurvey.INIT_TYPE, fetchSurvey)
  yield takeEvery(actions.submitSurvey.INIT_TYPE, submitSurvey)
}
